import api from './index';
//
let exports = {};

exports.existMerchantQualiTrade = function (params, callback) {// 是否存在交易资质
    api.post('/merchtQuali/trade/exist')
    .data(params)
    .done(callback)
    .fail(callback)
    .go();
};

//
exports.getMerchantTypeGroupList = function (data, callback) {// 根据不同商户查看不同的资质
    api.post('/merchtQuali/merchant/type/group/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getMerchantTypeGroupListByTypeNameAndMandLevel = function (postData, callback) {// 根据不同资质名称和资质类型查看不同的资质
    api.post('/merchtQuali/merchant/type/group/list/get/by/typeName/and/mandLevel')
    .data(postData)
    .done(callback)
    .go();
};

exports.saveMerchantQuali = function (data, callback) {// 保存申请资质
    api.post('/merchtQuali/merchant/quali/save/do')
    .data(data)
    .done(callback)
    .go();
};

// 查看资质详细信息
exports.getMerchantQualiInfoByMerchantIdAndQualiTypeId = function (data, callback) {// 查看商户申请资质
    api.post('/merchtQuali/merchant/quali/info/get/by/merchantId/and/qualiTypeId')
    .data(data)
    .done(callback)
    .go();
};

// 获取交易资质
exports.getMerchantTradeQualiStatusList = function (data, callback) {// 获取该商户已设置的交易资质
    api.post('/merchtQuali/merchant/trade/quali/status/list/get')
    .data(data)
    .done(callback)
    .go();
};

// 识别营业执照
exports.getBizLicenseOcrResult = function (params, callback) {// 获取营业执照识别结果
    api.get('/merchtQuali/biz/license/ocr/result/get')
    .params(params)
    .done(callback)
    .go();
};

exports.applyMerchantQuali = function (postData, callback) {// 申请资质
    api.post('/merchtQuali/merchant/quali/apply/do')
    .data(postData)
    .done(callback)
    .go();
};

exports.getMerchantQualiAuditRecList = function (postData, callback) {// 查看审核的记录
    api.post('/merchtQuali/merchant/quali/audit/rec/list/get')
    .data(postData)
    .done(callback)
    .go();
};

// ================ 员工资质 ==================

exports.getStaffQualiByFilter = function (postData, callback) {// 根据merchantType获取员工资质
    api.post('/merchtQuali/staff/quali/by/filter')
    .data(postData)
    .done(callback)
    .go();
};

// ================================= 零售商人员资质 ==============================

exports.getRetailerStaffQualiList = function (data, callback) {// 获得零售商人员资质列表
    api.post('/merchtQuali/retailer/staff/quali/list/get')
    .data(data)
    .done(callback)
    .go();
};

exports.getRetailerStaffQuali = function (params, callback) {// 获得零售商人员资质信息
    api.get('/merchtQuali/retailer/staff/quali/get')
    .params(params)
    .done(callback)
    .go();
};

exports.saveRetailerStaffQuali = function (data, callback) {// 零售商人员资质信息-新增
    api.post('/merchtQuali/retailer/staff/quali/save/do')
    .data(data)
    .done(callback)
    .go();
};

exports.updateRetailerStaffQuali = function (data, callback) {// 零售商人员资质信息-修改
    api.post('/merchtQuali/retailer/staff/quali/update/do')
    .data(data)
    .done(callback)
    .go();
};

exports.retailerStaffQualiForChecked = function (data, callback) {// 零售商人员资质信息-核实
    api.post('/merchtQuali/retailer/staff/quali/check/do')
    .data(data)
    .done(callback)
    .go();
};

exports.retailerStaffQualiForDisabled = function (data, callback) {// 零售商人员资质信息-启用-禁用
    api.post('/merchtQuali/retailer/staff/quali/disabled/do')
    .data(data)
    .done(callback)
    .go();
};

exports.deleteRetailerStaffQuali = function (data, callback) {// 零售商人员资质信息-删除
    api.post('/merchtQuali/retailer/staff/quali/delete/do')
    .data(data)
    .done(callback)
    .go();
};

exports.doRetailerStaffQualiBind = function (data, callback) {// 零售商人员资质-纳入
    api.post('/merchtQuali/retailer/staff/quali/bind/do')
    .data(data)
    .done(callback)
    .go();
};

exports.doRetailerStaffQualiSync = function (data, callback) {// 零售商人员资质-同步
    api.post('/merchtQuali/retailer/staff/quali/sync/do')
        .data(data)
        .done(callback)
        .go();
};

// ================ 商户人员资质类型 ==================

exports.getMerchtStaffQualiTypePaginatedList = function (postData, callback) { // 获得商户人员资质类型分页列表
    api.post('/merchtQuali/mercht/staff/quali/paginated/list/get')
    .data(postData)
    .done(callback)
    .go();
};

exports.getMerchtStaffQualiTypeList = function (postData, callback) { // 获得商户人员资质类型列表
    api.post('/merchtQuali/mercht/staff/quali/list/get')
    .data(postData)
    .done(callback)
    .go();
};

exports.getMerchtStaffQualiType = function (data, callback) { // 【商户人员资质类型】查询
    api.post('/merchtQuali/mercht/staff/quali/type/get')
    .data(data)
    .done(callback)
    .go();
};

exports.saveMerchtStaffQualiType = function (data, callback) { // 保存商户人员资质类型
    api.post('/merchtQuali/mercht/staff/quali/type/save/do')
    .data(data)
    .done(callback)
    .go();
};
exports.saveMerchtStaffQualiTypeByPlat = function (data, callback) { // 保存商户人员资质类型-从平台选择新增
    api.post('/merchtQuali/mercht/staff/quali/type/save/by/plat/do')
    .data(data)
    .done(callback)
    .go();
};
exports.doMerchtStaffQualiTypeConnPlat = function (data, callback) { // 商户人员资质类型-关联平台资质类型
    api.post('/merchtQuali/mercht/staff/quali/type/conn/plat/do')
    .data(data)
    .done(callback)
    .go();
};

exports.deleteMerchtStaffQualiType = function (data, callback) { // 删除商户人员资质类型
    api.post('/merchtQuali/mercht/staff/quali/type/delete/do')
    .data(data)
    .done(callback)
    .go();
};

// ================ 商户人员资质类型等级 ==================

exports.getMerchtStaffQualiTypeLevelListByTypeId = function (postData, callback) { // 获得商户人员资质类型列表
    api.post('/merchtQuali/mercht/staff/quali/level/list/get/by/typeId')
    .data(postData)
    .done(callback)
    .go();
};

exports.getRetailerStaffQualis = function (postData, callback) { // 获得零售商人员资质列表
    api.post('/merchtQuali/retailer/staff/qualis/get')
    .data(postData)
    .done(callback)
    .go();
};

//
export default exports;



//////////////////
// WEBPACK FOOTER
// ./src/api/merchtQuali.js
// module id = 56
// module chunks = 0